import { BrowserStorage } from "@jti/rest-api";

const storage = new BrowserStorage();
const PAYMENT_TOKEN = "paymentToken";

export const setPaymentTokenToStorage = (token: string): void => storage.set<string>(PAYMENT_TOKEN, token);

export const getPaymentTokenFromStorage = (defaultValue = ""): string =>
  storage.get<string>(PAYMENT_TOKEN, "") || defaultValue;

export const deletePaymentTokenFromStorage = (): void => storage.delete(PAYMENT_TOKEN);
